var CustomDB2 = {};

CustomDB2.DeliveryDate = (function () {
  /* There are 9 delivery zones (1-7 within USA), indicated by numbers:
  1. CT, MA, ME, NH, NJ, NY, RI, VT.
  2. DE, DC, Federal Government, MD, PA, VA, WV.
  3. GA, IL, IN, KY, MI, NC, OH, SC, TN, WI.
  4. AL, AR, FL, IA, LA, MN, MO, MS.
  5. CO, KS, MT, ND, NE, OK, SD, TX, WY.
  6. AZ, CA, ID, NM, NV, OR, UT, WA.
  7. AK, HI, PR (Puerto Rico).
  8. International.
  9. APO/FPO (Army/Fleet Post Office). I decided to add this zone, because shipping to APO/FPO addresses
    can take up to 30 days and NYD can't expedite this shipping service.
    Thus, the delivery date can't be calculated for this case.
  */

  /* The relation of ZIP codes to US states is based on the image
  https://upload.wikimedia.org/wikipedia/commons/thumb/2/24/ZIP_Code_zones.svg/1280px-ZIP_Code_zones.svg.png
  from https://en.wikipedia.org/wiki/ZIP_Code#Primary_state_prefixes.
  */
  var ZIPToZone = {
    '005': 1, // NY, out-of-range exception
    '006': 7, // PR
    '007': 7, // PR
    '008': 7, // PR
    '009': 7, // PR
    '01': 1, // MA
    '020': 1, // MA
    '021': 1, // MA
    '022': 1, // MA
    '023': 1, // MA
    '024': 1, // MA
    '025': 1, // MA
    '026': 1, // MA
    '027': 1, // MA
    '028': 1, // RI
    '029': 1, // RI
    '030': 1, // NH
    '031': 1, // NH
    '032': 1, // NH
    '033': 1, // NH
    '034': 1, // NH
    '035': 1, // NH
    '036': 1, // NH
    '037': 1, // NH
    '038': 1, // NH
    '039': 1, // ME
    '04': 1, // ME
    '05': 1, // VT
    '06': 1, // CT
    '07': 1, // NJ
    '08': 1, // NJ
    /* 09 is for:
    - Army Post Office Europe, Central Asia, and the Middle East (APO AE);
    - Fleet Post Office Europe and the Middle East (FPO AE).
    */
    '09': 9,
    '10': 1, // NY
    '11': 1, // NY
    '12': 1, // NY
    '13': 1, // NY
    '14': 1, // NY
    '15': 2, // PA
    '16': 2, // PA
    '17': 2, // PA
    '18': 2, // PA
    '190': 2, // PA
    '191': 2, // PA
    '192': 2, // PA
    '193': 2, // PA
    '194': 2, // PA
    '195': 2, // PA
    '196': 2, // PA
    '197': 2, // DE
    '198': 2, // DE
    '199': 2, // DE
    '200': 2, // DC
    '201': 2, // VA
    '202': 2, // Federal Government
    '203': 2, // Federal Government
    '204': 2, // Federal Government
    '205': 2, // Federal Government
    '206': 2, // MD
    '207': 2, // MD
    '208': 2, // MD
    '209': 2, // MD
    '21': 2, // MD
    '22': 2, // VA
    '23': 2, // VA
    '240': 2, // VA
    '241': 2, // VA
    '242': 2, // VA
    '243': 2, // VA
    '244': 2, // VA
    '245': 2, // VA
    '246': 2, // VA
    '247': 2, // WV
    '248': 2, // WV
    '249': 2, // WV
    '25': 2, // WV
    '26': 2, // WV
    '27': 3, // NC
    '28': 3, // NC
    '29': 3, // SC
    '30': 3, // GA
    '31': 3, // GA
    '32': 4, // FL
    '33': 4, // FL
    /* 340 is for:
    - Army Post Office Americas (APO AA);
    - Fleet Post Office Americas (FPO AA).
    */
    '340': 9,
    '341': 4, // FL
    '342': 4, // FL
    '343': 4, // FL
    '344': 4, // FL
    '345': 4, // FL
    '346': 4, // FL
    '347': 4, // FL
    '348': 4, // FL
    '349': 4, // FL
    '35': 4, // AL
    '36': 4, // AL
    '37': 3, // TN
    '380': 3, // TN
    '381': 3, // TN
    '382': 3, // TN
    '383': 3, // TN
    '384': 3, // TN
    '385': 3, // TN
    '386': 4, // MS
    '387': 4, // MS
    '388': 4, // MS
    '389': 4, // MS
    '390': 4, // MS
    '391': 4, // MS
    '392': 4, // MS
    '393': 4, // MS
    '394': 4, // MS
    '395': 4, // MS
    '396': 4, // MS
    '397': 4, // MS
    '398': 3, // GA
    '399': 3, // GA
    '40': 3, // KY
    '41': 3, // KY
    '42': 3, // KY
    '43': 3, // OH
    '44': 3, // OH
    '45': 3, // OH
    '46': 3, // IN
    '47': 3, // IN
    '48': 3, // MI
    '49': 3, // MI
    '50': 4, // IA
    '51': 4, // IA
    '52': 4, // IA
    '53': 3, // WI
    '54': 3, // WI
    '55': 4, // MN
    '560': 4, // MN
    '561': 4, // MN
    '562': 4, // MN
    '563': 4, // MN
    '564': 4, // MN
    '565': 4, // MN
    '566': 4, // MN
    '567': 4, // MN
    // No location found for 568
    '569': 2, // DC, out-of-range exception
    '57': 5, // SD
    '58': 5, // ND
    '59': 5, // MT
    '60': 3, // IL
    '61': 3, // IL
    '62': 3, // IL
    '63': 4, // MO
    '64': 4, // MO
    '65': 4, // MO
    '66': 5, // KS
    '67': 5, // KS
    '68': 5, // NE
    '69': 5, // NE
    '70': 4, // LA
    '710': 4, // LA
    '711': 4, // LA
    '712': 4, // LA
    '713': 4, // LA
    '714': 4, // LA
    '715': 4, // LA
    '716': 4, // AR
    '717': 4, // AR
    '718': 4, // AR
    '719': 4, // AR
    '72': 4, // AR
    '73': 5, // OK
    '74': 5, // OK
    '75': 5, // TX
    '76': 5, // TX
    '77': 5, // TX
    '78': 5, // TX
    '79': 5, // TX
    '80': 5, // CO
    '81': 5, // CO
    '82': 5, // WY
    '830': 5, // WY
    '831': 5, // WY
    '832': 6, // ID
    '833': 6, // ID
    '834': 6, // ID
    '835': 6, // ID
    '836': 6, // ID
    '837': 6, // ID
    '838': 6, // ID
    '839': 6, // ID
    '84': 6, // UT
    '85': 6, // AZ
    '86': 6, // AZ
    '87': 6, // NM
    '880': 6, // NM
    '881': 6, // NM
    '882': 6, // NM
    '883': 6, // NM
    '884': 6, // NM
    '885': 5, // TX, out-of-range exception
    // No location found for 886-888
    '889': 6, // NV
    '89': 6, // NV
    '90': 6, // CA
    '91': 6, // CA
    '92': 6, // CA
    '93': 6, // CA
    '94': 6, // CA
    '95': 6, // CA
    '960': 6, // CA
    '961': 6, // CA
    /* 962-966 is for:
    - Army Post Office Pacific (APO AP);
    - Fleet Post Office Pacific (FPO AP).
    */
    '962': 9,
    '963': 9,
    '964': 9,
    '965': 9,
    '966': 9,
    '967': 7, // HI
    '968': 7, // HI
    /* 969 is for:
    - Federated States of Micronesia (FM);
    - Guam (GU);
    - Marshall Islands (MH);
    - Northern Mariana Islands (MP);
    - Palau (PW).
    Considered international.
    */
    '97': 6, // OR
    '98': 6, // WA
    '990': 6, // WA
    '991': 6, // WA
    '992': 6, // WA
    '993': 6, // WA
    '994': 6, // WA
    '995': 7, // AK
    '996': 7, // AK
    '997': 7, // AK
    '998': 7, // AK
    '999': 7, // AK
  };

  /* AS (American Samoa) thus international shipping but in the range of HI (Hawaii).
  So it must be checked first.
  */
  var ZIPExceptionAS = '96799';

  /* Delivery days depending on vendor location.
  Arrays of 8 digits represent days needed for delivery if an order was made before cut-off time.
  Each digit corresponds to a specific zone from 1 to 8.
  */
  var days = {
    // USA states
    CA: [7, 6, 5, 4, 3, 2, 3, 5],
    CA2: [8, 7, 6, 5, 4, 3, 4, 6],
    FL: [3, 3, 3, 3, 4, 5, 3, 5],
    IL: [4, 4, 2, 3, 4, 5, 3, 5],
    IL2: [5, 5, 3, 4, 5, 6, 4, 6],
    MA: [2, 3, 4, 5, 6, 7, 3, 5],
    ME: [2, 3, 4, 5, 6, 7, 3, 5],
    NJ: [2, 2, 3, 4, 5, 6, 3, 5],
    NY: [2, 2, 3, 4, 5, 6, 3, 5],
    OK: [7, 5, 4, 3, 2, 3, 3, 5],
    PA: [2, 2, 3, 4, 5, 6, 3, 5],
    TX: [7, 5, 4, 3, 2, 3, 3, 5],
    VA: [2, 2, 3, 4, 5, 6, 3, 5],
    WA: [7, 6, 5, 4, 3, 2, 3, 5],
    // Other countries
    Australia: [6, 6, 6, 6, 6, 6, 6, 5],
    Belgium: [4, 4, 4, 4, 4, 4, 4, 5],
    Canada: [3, 3, 3, 3, 4, 5, 3, 5],
    China: [7, 7, 7, 7, 7, 7, 7, 6],
    France: [4, 4, 4, 4, 4, 4, 4, 5],
    India: [6, 6, 6, 6, 6, 6, 6, 5],
    Lebanon: [4, 4, 4, 4, 4, 4, 4, 5],
    Spain: [6, 6, 6, 6, 6, 6, 6, 5],
    Turkey: [6, 6, 6, 6, 6, 6, 6, 5],
    Turkey2: [4, 4, 4, 4, 4, 4, 4, 5],
  };

  /* Fields:
  1. 'from', 'to': inventory quantity range.
  2. 'time': cut-off time, pm EST.
  3. 'days': see description for var days.
  */
  var mainDataset = {
    'Abby Paris': [
      { from: 1, to: 199, time: 2, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Alyce': [
      { from: 1, to: 199, time: 2, days: days.IL },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Amarra': [
      { from: 1, to: 499, time: 2, days: days.NJ },
    ],
    'Andrea and Leo': [
      { from: 1, to: 199, time: 4, days: days.CA2 },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Angela and Alison': [
      { from: 1, to: 199, time: 2, days: days.Canada },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Anny Lee': [
      { from: 1, to: 199, time: 4, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Ashley Lauren': [
      { from: 1, to: 199, time: 2, days: days.ME },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Ava Presley': [
      { from: 1, to: 199, time: 3, days: days.TX },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Cameron Blake': [
      { from: 1, to: 199, time: 2, days: days.IL },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Cecilia Couture': [
      { from: 1, to: 199, time: 4, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Chic and Holland': [
      { from: 201, to: 299, time: 2, days: days.NY },
      { from: 401, to: 499, time: 2, days: days.Belgium, isPreOrder: true },
    ],
    'Cinderella Divine': [
      { from: 1, to: 199, time: 4, days: days.CA2 },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Clarisse': [
      { from: 1, to: 499, time: 2, days: days.PA },
    ],
    'Colette': [
      { from: 1, to: 199, time: 2, days: days.IL },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Colors Dress': [
      { from: 1, to: 499, time: 2, days: days.NJ },
    ],
    'Couture Fashion by FG': [
      { from: 1, to: 199, time: 2, days: days.India },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Daymor': [
      { from: 1, to: 499, time: 2, days: days.MA },
    ],
    'Dulce Celia': [
      { from: 1, to: 199, time: 2, days: days.NY },
      { from: 401, to: 499, time: 2, days: days.France, isPreOrder: true },
    ],
    'Edition Gemmy Malouf': [
      { from: 1, to: 199, time: 2, days: days.NY },
      { from: 401, to: 499, time: 2, days: days.Lebanon, isPreOrder: true },
    ],
    'Edward Arsouni Couture': [
      { from: 1, to: 199, time: 2, days: days.NY },
      { from: 401, to: 499, time: 2, days: days.Lebanon, isPreOrder: true },
    ],
    'Elizabeth K': [
      { from: 1, to: 199, time: 4, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Ellie Wilde': [
      { from: 1, to: 199, time: 2, days: days.IL },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Faviana': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'Fely Campo': [
      { from: 1, to: 199, time: 2, days: days.Spain },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Feriani': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'Gatti Nolli Couture': [
      { from: 1, to: 199, time: 2, days: days.NY },
      { from: 401, to: 499, time: 2, days: days.Lebanon, isPreOrder: true },
    ],
    'Gia Franco': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'GLS by Gloria': [
      { from: 1, to: 199, time: 4, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Ilmio': [
      { from: 1, to: 199, time: 2, days: days.Turkey },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'In Couture': [
      { from: 1, to: 199, time: 2, days: days.Turkey },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Issue NY': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'Ivonne D': [
      { from: 1, to: 199, time: 2, days: days.IL },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Jadore': [
      { from: 1, to: 199, time: 2, days: days.Canada },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Janique': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'Jean Louis Sabaji': [
      { from: 1, to: 199, time: 2, days: days.NY },
      { from: 401, to: 499, time: 2, days: days.Lebanon, isPreOrder: true },
    ],
    'Johnathan Kayne': [
      { from: 1, to: 199, time: 3, days: days.OK },
      { from: 201, to: 299, time: 2, days: days.NY },
      { from: 401, to: 499, time: 3, days: days.OK, isPreOrder: true },
    ],
    'Jovani': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'JVN by Jovani': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'LaDivine': [
      { from: 1, to: 199, time: 4, days: days.CA2 },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'La Femme': [
      { from: 1, to: 199, time: 4, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
      { from: 401, to: 499, time: 4, days: days.CA, isPreOrder: true },
    ],
    'Lara': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'Les Demoiselle': [
      { from: 1, to: 199, time: 2, days: days.Australia },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Lucci Lu': [
      { from: 1, to: 199, time: 2, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Mac Duggal': [
      { from: 1, to: 199, time: 2, days: days.IL2 },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Marsoni': [
      { from: 1, to: 499, time: 2, days: days.NJ },
    ],
    'MGNY': [
      { from: 1, to: 199, time: 2, days: days.FL },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'MINNA': [
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'MNM Couture': [
      { from: 1, to: 199, time: 2, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Montage': [
      { from: 1, to: 199, time: 2, days: days.IL },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Nox Anabel': [
      { from: 1, to: 199, time: 4, days: days.CA },
      { from: 201, to: 299, time: 4, days: days.NY },
    ],
    'Odrella': [
      { from: 1, to: 199, time: 2, days: days.Turkey },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Park 108': [
      { from: 1, to: 499, time: 2, days: days.MA },
    ],
    'Paul Rekhi': [
      { from: 1, to: 199, time: 2, days: days.VA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Portia and Scarlett': [
      { from: 1, to: 199, time: 4, days: days.China },
      { from: 201, to: 299, time: 2, days: days.NY },
      { from: 301, to: 399, time: 4, days: days.CA },
    ],
    'Primavera Couture': [
      { from: 1, to: 199, time: 2, days: days.FL },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Rachel Allan': [
      { from: 1, to: 199, time: 3, days: days.TX },
      { from: 201, to: 299, time: 2, days: days.NY },
      { from: 401, to: 499, time: 3, days: days.TX, isPreOrder: true },
    ],
    'Reverie Couture': [
      { from: 1, to: 199, time: 2, days: days.NY },
      { from: 401, to: 499, time: 2, days: days.Turkey2, isPreOrder: true },
    ],
    'Rina Di Montella': [
      { from: 1, to: 499, time: 2, days: days.NJ },
    ],
    'Scala': [
      { from: 1, to: 199, time: 2, days: days.CA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Sherri Hill': [
      { from: 1, to: 199, time: 3, days: days.TX },
      { from: 201, to: 299, time: 2, days: days.NY },
      { from: 401, to: 499, time: 3, days: days.TX, isPreOrder: true },
    ],
    'Sydneys Closet': [
      { from: 1, to: 199, time: 2, days: days.WA },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
    'Tarik Ediz': [
      { from: 1, to: 199, time: 2, days: days.Turkey },
      { from: 401, to: 499, time: 2, days: days.Turkey2, isPreOrder: true },
    ],
    'Terani': [
      { from: 1, to: 499, time: 2, days: days.NY },
    ],
    'Tiara': [
      { from: 1, to: 199, time: 2, days: days.Turkey },
      { from: 201, to: 299, time: 2, days: days.NY },
    ],
  };

  function getZone(country, ZIP) {
    if (country === 'Puerto Rico') return 7;
    if (country !== 'United States') return 8;
    // User can select 'United States' despite 'American Samoa' is also in the list of countries
    if (ZIP === ZIPExceptionAS) return 8;
    // Try to find zone by the first two digits of ZIP code
    var zone = ZIPToZone[ZIP.slice(0, 2)];
    if (zone) return zone;
    /* If the first two digits of ZIP code are shared between two or more states,
    use the first three digits for more precise search.
    */
    zone = ZIPToZone[ZIP.slice(0, 3)];
    if (zone) return zone;
    return 8;
  }

  // ZIP is null if not the USA
  function get(vendor, inventoryQuantity, country, ZIP) {
    if (!vendor || !inventoryQuantity || !country) return null;
    if (country === 'United States' && ZIP.length < 2) return null;
    var zone = getZone(country, ZIP);
    if (zone === 9) return { isMilitary: true };
    var vendorLocations = mainDataset[vendor];
    if (!vendorLocations) return null;
    var vendorLocation = vendorLocations.find(function (v) {
      return inventoryQuantity >= v.from && inventoryQuantity <= v.to;
    });
    if (!vendorLocation) return null;
    var days = vendorLocation.days[zone - 1];
    if (vendorLocation.isPreOrder) return { days: days, isPreOrder: true };
    return { cutoffTime: vendorLocation.time, days: days };
  }

  return {
    get: get,
  };
}());
